import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './icon.css';
// import './assets/scss/admin.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { registerLicense } from "@syncfusion/ej2-base";
registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF1cWWhIfkx3RHxbf1x0ZFRMY1xbRHJPIiBoS35RckVqWH1edXVQRGdaVEF2');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
